import { getPosts, SavedSinglePost } from "./postApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    posts: [],
    savedPosts: [],
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchposts = createAsyncThunk("posts/fetchposts", async ({filter,sort}) => {

    const posts = await getPosts({filter,sort});
    console.log('first', filter,sort,posts)
    return  posts;
});

export const SavedSinglepost = createAsyncThunk("post/SavedSinglepost", async (post) => {
    const posts = await SavedSinglePost(post);
    return posts?.data;
});
const postSlice = createSlice({
    name: "posts",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchposts.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchposts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.posts = action.payload;
                state.savedPosts = action.payload?.filter(post => (post.isSaved?.toString()=="true"));
            })
            .addCase(fetchposts.rejected, (state, action) => {
                state.isLoading = false;
                state.posts = [];
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(SavedSinglepost.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(SavedSinglepost.fulfilled, (state, action) => {
                state.isLoading = false;
                
              
             
            })
            .addCase(SavedSinglepost.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
    },
});

export default postSlice.reducer;